export default __webpack_public_path__ + "static/media/download_icon.78d36a1d.svg";